import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnInit, viewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IGridCreatedEventArgs, IgxHierarchicalGridComponent, SortingDirection } from '@infragistics/igniteui-angular';

import { MutationModel } from '../../../models/mutation.model';
import { ControllerService } from '../../../services/controller.service';
import { MutationsResource } from '../../../services/resources/mutations.resource';

@Component({
    selector: 'sl-mutations',
    templateUrl: './mutations.component.html',
    styleUrls: ['./mutations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MutationsComponent implements OnInit, AfterViewInit {
    grid = viewChild.required('grid', { read: IgxHierarchicalGridComponent });

    mutations: MutationModel[] = [];

    private readonly mutationsResource = inject(MutationsResource);
    private readonly controllerService = inject(ControllerService);
    private readonly dialogRef = inject(MatDialogRef<MutationsComponent>);

    ngOnInit(): void {
        const currentResponse = this.controllerService.currentResponse;

        if (!!currentResponse) {
            this.mutations = currentResponse.value;
        }

        this.controllerService.currentResponse = undefined;
    }

    ngAfterViewInit(): void {
        // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        this.grid().sortingExpressions = [
            {
                fieldName: 'createdTime',
                dir: SortingDirection.Desc
            }
        ];
        this.grid().cdr.detectChanges();
    }

    loadChildren(event: IGridCreatedEventArgs): void {
        event.grid.isLoading = true;
        this.mutationsResource.getFields(event.parentID).subscribe(r => {
            event.grid.isLoading = false;
            event.grid.data = r.value;
            event.grid.cdr.detectChanges();
        });
    }

    close(): void {
        this.dialogRef.close();
    }
}
